import RepositoryService from 'src/services/repository'

const resource = 'onTime/session'

export default RepositoryService.utils.createCrudRepository(resource)
